import React from "react";
import { useDeleteLevelMutation } from "../../../utils/api/level/level.api";
import { ILevel } from "../../../utils/api/level/level.type";
import { useDelete } from "../../../utils/helpers";
import { useLevels } from "../../admin/Settings/Tabs/useForm/useCrudLevel";
import AddLevelModal from "../../modals/admin/AddLevelModal";
import { Button, ButtonDelete, ButtonEdit } from "../../shared/Button";
const columns = ["Niveau", "Actions"];
const LevelsTable = () => {
	const { data, isLoading, openModal, showModal, toggleModal, item, editModal } = useLevels();
	return (
		<React.Fragment>
			<div className="flex justify-end">
				<Button label="Ajouter" onClick={openModal} type="button" />
			</div>
			<AddLevelModal showModal={showModal} toggleModal={toggleModal} item={item} />
			<div className="table-container">
				<table className="table-custom">
					<thead className="thead">
						<tr>
							{columns?.map((column, index) => (
								<th scope="col" className="py-3 px-6" key={index}>
									{column}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{data?.map((item) => (
							<tr className="bg-white border-b" key={item?.slug}>
								<td className="table-td">{item?.name}</td>
								<td>
									<div className="flex gap-3 px-5">
										<ButtonEdit
											onClick={() => editModal(item)}
										/>
										<DeleteLevel item={item} />
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</React.Fragment>
	);
};

export function DeleteLevel({ item }: { item: ILevel }) {
	const [deleteItem, { isSuccess, isError, error }] = useDeleteLevelMutation();
	const onDelete = useDelete<ILevel>({
		item,
		deleteItem,
		isSuccess,
		isError,
		error,
		successMessage: "Niveau supprimé",
	});
	return <ButtonDelete onClick={onDelete} />;
}
export default LevelsTable;
